import gql from "graphql-tag";

const GET_9142C_FORM_DATA = gql`
  query getForm9142CById($id: String!) {
    getForm9142CById(id: $id) {
      payload {
        meta_user_id
        meta_case_number
        meta_case_type_id
        meta_case_status
        a1_application_type
        a2_permit_renewal_date
        a3_is_long_term
        a4_is_cap_exempt
        a5_is_emergency
        a6_emergency_attached
        a7_emergency_attached
        a6_emergency_justification
        a6_9141
        a7_9141_attached
        b1_emp_name
        b2_emp_dba
        b3_emp_address_1
        b4_emp_address_2
        b5_emp_city
        b6_emp_state_id
        b7_emp_zip
        b8_emp_country_id
        b9_emp_province
        b10_emp_phone
        b11_emp_phone_ext
        b12_emp_fein
        b13_emp_naics
        b13_emp_naics_description
        b14_emp_type_id
        b15_appx_a_attached
        b16_contract_file
        b16_contract_attached
        c1_poc_last
        c2_poc_first
        c3_poc_middle
        c4_poc_title
        c5_poc_address_1
        c6_poc_address_2
        c7_poc_city
        c8_poc_state_id
        c9_poc_zip
        c10_poc_country_id
        c11_poc_province
        c12_poc_phone
        c13_poc_phone_ext
        c14_poc_email
        d1_agent_type_id
        d2_agent_last
        d3_agent_first
        d4_agent_middle
        d5_agent_address_1
        d6_agent_address_2
        d7_agent_city
        d8_agent_state_id
        d9_agent_zip
        d10_agent_country_id
        d11_agent_province
        d12_agent_phone
        d13_agent_phone_ext
        d14_agent_email
        d15_agent_firm_name
        d16_agent_firm_fein
        d17_agent_bar_number
        d18_agent_court_state_id
        d19_agent_court_name
        d20_agent_agreement_attached
        d20_agent_agreement_attached_attached
        ea1_soc_code
        ea2_soc_title
        ea3_pwd_number
        eb1_job_title
        eb2_num_workers
        eb3_start_date
        eb4_end_date
        eb5_job_duties
        eb6a_hours_total
        eb6b_hours_sunday
        eb6c_hours_monday
        eb6d_hours_tuesday
        eb6e_hours_wednesday
        eb6f_hours_thursday
        eb6g_hours_friday
        eb6h_hours_saturday
        eb7a_start_time
        eb7b_end_time
        eb8_education_id
        eb9_training_months
        eb10_experience_months
        eb11_is_supervision
        eb11a_number_supervised
        eb12_special_requirements
        ec1_work_address_1
        ec2_work_address_2
        ec3_work_city
        ec4_work_state_id
        ec5_work_zip
        ec6_basic_rate_from
        ec6_basic_rate_to
        ec6a_overtime_rate_from
        ec6a_overtime_rate_to
        ec7_pay_rate_id
        ec7a_pay_comments
        ec8_pay_frequency_id
        ec8_pay_frequency_other
        ec9_is_multiple_locations
        ec10_appx_b_attached
        ed1_assurance
        ed2_assurance
        ed3_assurance
        ed4_assurance
        ed5_assurance
        ed6_assurance
        ed7_deductions
        ee1_how_to_apply
        ee2_apply_phone
        ee3_apply_email
        ee4_apply_website
        ef_1_assurance
        ef_1_assurance_attached
        ef_2_assurance
        ef_2_assurance_attached
        eg1_prep_last
        eg2_prep_first
        eg3_prep_middle
        eg4_prep_fein
        eg5_prep_firm_name
        eg6_prep_email

        appx_a_emp_name
        appx_a_emp_dba
        appx_a_emp_address_1
        appx_a_emp_address_2
        appx_a_emp_city
        appx_a_emp_state_id
        appx_a_emp_zip
        appx_a_emp_country_id
        appx_a_emp_province
        appx_a_emp_phone
        appx_a_emp_phone_ext
        appx_a_emp_fein
        appx_a_emp_naics
        appx_a_emp_naics_description
        appx_a_poc_last
        appx_a_poc_first
        appx_a_poc_middle
        appx_a_poc_title
        appx_a_poc_address_1
        appx_a_poc_address_2
        appx_a_poc_city
        appx_a_poc_state_id
        appx_a_poc_zip
        appx_a_poc_country_id
        appx_a_poc_province
        appx_a_poc_phone
        appx_a_poc_phone_ext
        appx_a_poc_email

        appx_b_locations {
          pwdWageRate
          pwdUnitOfPay
          sort_order
          worksiteBlsArea
          worksiteBlsAreaId
          worksiteCity
          worksiteState
          worksitePostalCode
          worksiteCountyOrBlsArea
          worksiteCountyTownship
          dateSubmitted
          determinationDate
          rowNum
        }
        appx_b {
          # determined_wage
          # determined_wage_per
          appx_b_city
          appx_b_state_id
          appx_b_zip
          appx_b_employment_info
          appx_b_crew_id
          appx_b_total_workers
          appx_b_begin_date
          appx_b_end_date
          appx_b_wage_from
          appx_b_wage_to
          appx_b_wage_freq

          # meta_case_submit_date
          # meta_case_determined_date
          # _bls_counties
          # sort_order
          id
          # rowNum
        }

        files {
          machine_name
          application_id
          FileType
          fileType
          document_name
          size
          displayName
          lastModified
          state
          percentage
          document_path
        }
      }

      form_ui {
        pages_visited
        pages_errors
      }
    }
  }
`;

const SUBMIT_9142C_FORM = gql`
  mutation SubmitForm9142C(
    $id: String!
    $Form9142CFormData: Form9142CFormData!
    $token: String
  ) {
    SubmitForm9142C(
      Form9142CFormData: $Form9142CFormData
      id: $id
      token: $token
    )
  }
`;

const UPDATE_9142C_FORM = gql`
  mutation updateForm9142CById(
    $id: String!
    $Form9142CFormData: Form9142CFormData!
    $formUI9142C: formUIInput
    $profilePrefillMetadata: [ProfilePrefillMetadataInput!]
  ) {
    updateForm9142CById(
      id: $id
      Form9142CFormData: $Form9142CFormData
      formUI9142C: $formUI9142C
      profilePrefillMetadata: $profilePrefillMetadata
    )
  }
`;

const GET_9142C_PROFILES = gql`
  query {
    getUserProfileInfo {
      EmployerProfiles {
        employer_id
        employer_name
      }
      EmployerPOCProfiles {
        employer_poc_id
        employer_poc_name
      }
      AgentProfiles {
        agent_id
        agent_name
      }
      AgentIndividualProfiles {
        agent_ind_id
        agent_ind_name
      }
      RecruiterProfiles {
        recruiter_id
        recruiter_name
        first_name
        last_name
        employer_name
        city
        state
        country
      }
      CropProfiles {
        crop_id
        crop_work_state
        crop_name
        crop_agricultural_activity
      }
      AgricultureProfiles {
        agriculture_id
        agriculture_name
        agriculture_emp_name
        agriculture_state
        agriculture_county
      }
      WorkerHousingProfiles {
        workerHousing_id
        workerHousing_type_of_housing
        workerHousing_state
        workerHousing_state
        workerHousing_county
        workerHousing_name
      }
      MaterialTermsProfiles {
        material_terms_id
        material_terms_profile_name
        material_terms_section_number
        material_terms_summary
        material_terms_details
      }
      ForeignWorkerProfiles {
        foreign_worker_id
        foreign_worker_name
        foreign_worker_first_name
        foreign_worker_first_middle
        foreign_worker_last_name
        foreign_worker_address
        foreign_worker_city
        foreign_worker_state
        foreign_worker_province
        foreign_worker_country
        foreign_worker_postal_code
        foreign_worker_dob
        foreign_worker_class
        foreign_worker_alien_number
        foreign_worker_birth_country
        foreign_worker_citizen_country
        new_profile_fw_education {
          appAEduTypeId
          appAEduOther
          appAEduMajors
          appAEduInstName
          appAEduCountryId
          appAEduMonthYearAttained
        }
        new_profile_fw_training_qualifications {
          appATrainingInstName
          appATrainingName
          appATrainingCert
          appATrainingStartDate
          appATrainingEndDate
          appATrainingYearAwd
        }
        new_profile_fw_skills {
          appASkillsInstName
          appASkillsInstName
          appASkillsCountryId
          appASkillsStateId
          fwTerritory
          appASkillsSpecial
        }
        new_profile_fw_work_experience {
          appAExpEmpName
          appAExpAddress1
          appAExpAddress2
          appAExpCity
          appAExpPostalCode
          appAExpCountryId
          appAExpStateTerritory
          appAExpProvince
          appAExpJobTitle
          appAExpStartDate
          appAExpEndDate
          appAExpFWPresent
          appAExpWorkHour
          appAExpJobDuties
        }
      }
      ForeignWorkerGroupProfiles {
        foreign_worker_group_id
        new_group_fw_group_name
        new_group_fw_profiles
        new_group_fw_num_profiles
      }
    }
  }
`;

export {
  GET_9142C_FORM_DATA,
  UPDATE_9142C_FORM,
  SUBMIT_9142C_FORM,
  GET_9142C_PROFILES, //No profiles used right now; leaving it for the future
};
